"use client"
import { Drawer, Spin } from 'antd'
import React, { useState } from 'react'
import "./style.css"
import formatMsg from "../../util/formatMsg";
import Helper from '../../util/helper';
import LinkWrapper from '../../components/linkWrapper/page';
import colors from '../../libs/colorFactory';
import { listingEndPointUrl } from '../../libs/fbConfig';
import { timeutil } from "sharedresources"
import styles from './style.module.css'

const ViewScheduleDrawer = (props) => {

  const { firebase, participantAttendanceStats } = props

  const replaceSpacesWithEncoded = (value: string): string => {
    return value.replace(/ /g, '%20');
  };

  function getAttendanceStats() {

    return (
      <div className={styles.headerSubText}>
        {(participantAttendanceStats?.present || 0) + ' Present'}
        <span className={styles.dot} />
        {(participantAttendanceStats?.absent || 0) + ' Absent'}
        <span className={styles.dot} />
        {(participantAttendanceStats?.pending || 0) + ' Pending'}
      </div>
    )
  }

  function getBookingStats() {

    return (
      <div className={`${styles.headerSubText} ${styles.mtBottom}`}>
        {(props.scheduleDetail?.waitlists?.length || 0) + ' Waitlisted'}
        <span className={styles.dot} />
        {(props.scheduleDetail?.confirmationPendings?.length || 0) + ' Confirmation Pending'}
      </div>
    )
  }

  console.log("props.scheduleDetail", props.scheduleDetail)

  return (
    <Drawer
      className='laptop-view-single-schedule-drawer parent-schedule-drawer'
      open={props.selectedSchedule ? true : false}
      title={
        <>
          <div className='displayFlexSpaceBetween'>
            {Helper.isAccount(props.firebase) ?
              <LinkWrapper href={`${listingEndPointUrl}/dashboard/packageDetailView?id=${props.selectedSchedule?.packageId}&centerId=${replaceSpacesWithEncoded(props.firebase.sbDbName)}`} target="_blank">
                <div className='displayFlex'>
                  <p className='global-title-subheader'>{props.selectedSchedule?.packageName}</p>
                  <img src='/images/redirect_img.png' style={{ height: 12, width: 12, marginLeft: 8 }} />
                </div>
              </LinkWrapper>
              : <LinkWrapper href={"/dashboard/package/packageDetailedView?id=" + props.selectedSchedule?.packageId} target="_blank">
                <div className='displayFlex'>
                  <p className='global-title-subheader'>{props.selectedSchedule?.packageName}</p>
                  <img src='/images/redirect_img.png' style={{ height: 12, width: 12, marginLeft: 8 }} />
                </div>
              </LinkWrapper>
            }
          </div>
          <div className='displayFlex' style={{ cursor: "pointer" }} onClick={props.drawerOnClose}>
            <img src='/images/black-cross.png' style={{ height: 22, width: 22, position: "fixed", top: 16, right: 24 }} />
          </div>
        </>
      }
      onClose={props.drawerOnClose}
      width={window?.innerWidth > 700 ? 650 : "80%"}
      closable={false}
    >
      <Spin spinning={props.isLoading}>
        <div className='drawer-activity-name'>{props.selectedSchedule?.activity?.name}</div>
        <div className='displayFlex'>
          <img src='/images/schedule.png' style={{ height: 14, width: 14, marginRight: 10 }} />
          <p className='drawer-schedule-detail'>{timeutil.getInstance(props.selectedSchedule?.date).format('dddd, DD MMMM YYYY')}</p>
        </div>
        {props.selectedSchedule?.activityName && firebase.schoolConfig.showPackageActivities && <div className='displayFlex mt-16'>
          <img src='/images/activityIcon.png' style={{ height: 14, width: 14, marginRight: 10 }} />
          <p className='drawer-schedule-detail'>{props.selectedSchedule?.activityName}</p>
        </div>}
        <div className='displayFlex mt-16'>
          <img src='/images/clock.png' style={{ height: 14, width: 14, marginInlineEnd: 10 }} />
          <p className='drawer-schedule-detail'>
            {timeutil.getInstance(props.selectedSchedule?.startTime).format('hh:mma') + " - " + timeutil.getInstance(props.selectedSchedule?.endTime).format('hh:mma')}
          </p>
        </div>
        <div className='displayFlex mt-16'>
          <img src='/images/clock.png' style={{ height: 14, width: 14, marginInlineEnd: 10 }} />
          <p className='drawer-schedule-detail'>
            {props.selectedSchedule?.batchName}
          </p>
        </div>
        {/* <div className='displayFlex mt-16'>
          <img src='/images/board.png' style={{ height: 14, width: 15, marginRight: 9 }} />
          <p className='drawer-schedule-detail'>{props.selectedSchedule?.instructors?.map(s => s.name).join(", ")}</p>
        </div> */}
        {/* <div className='drawer-heading'>{formatMsg("bookingDetails")}</div>
        <div className='displayFlex gap-25'>
          <div>
            <div className='displayFlex mt-16'>
              <img src='/images/confirm.png' style={{ height: 14, width: 14, marginInlineEnd: 10 }} />
              <p className='drawer-schedule-detail'>{"Confirmed Bookings"}</p>
            </div>
            <div className='displayFlex mt-16'>
              <img src='/images/waitlisted.png' style={{ height: 14, width: 14, marginInlineEnd: 10 }} />
              <p className='drawer-schedule-detail'>{"Waitlists"}</p>
            </div>
            <div className='displayFlex mt-16'>
              <img src='/images/waitlisted.png' style={{ height: 14, width: 14, marginInlineEnd: 10 }} />
              <p className='drawer-schedule-detail'>{"Confirmation Pending"}</p>
            </div>
          </div>
          <div>
            <div className='displayFlex mt-16'>
              <span className='drawer-schedule-detail'>:</span>&nbsp;&nbsp;{(props.scheduleDetail?.totalBookings?.length || 0) + " " + "seats"}
            </div>
            <div className='displayFlex mt-16'>
              <span className='drawer-schedule-detail'>:</span>&nbsp;&nbsp;{props.scheduleDetail?.waitlists?.length || "-"}
            </div>
            <div className='displayFlex mt-16'>
              <span className='drawer-schedule-detail'>:</span>&nbsp;&nbsp;{props.scheduleDetail?.confirmationPendings?.length || "-"}
            </div>
          </div>
        </div> */}

        <div>
          <div className="drawer-heading displayFlexSpaceBetweenNoWrap">
            <div>
              <img
                src='/images/twoUsers.png'
                className={styles.twoUsersImg}
              />
            </div>
            <div className={styles.headerText}>
              <div>
                {props.scheduleDetail?.students?.length || 0}
              </div>
              <div>
                {
                  (firebase?.schoolConfig?.useUserTypeAsDisplayName && firebase?.schoolConfig?.selectedUserTypeName)
                    ? firebase?.schoolConfig?.selectedUserTypeName
                    : formatMsg('users')
                }
              </div>
            </div>
          </div>
          {getAttendanceStats()}
          {getBookingStats()}
        </div>

        {(props.scheduleDetail?.students?.length)
          ? props.getParticipantsChildren()
          : <div className={styles.noParticipantsCont}>
            <img
              src="/images/noParticipantsV2.png"
              className={styles.noParticipantsImg}
            />
            <div className={styles.noParticipantsText}>
              {Helper.getSelectedUserTypeName(firebase, formatMsg("noParticipants"), formatMsg('no'), null, "LOWERCASE")}
            </div>
          </div>
        }
      </Spin>
    </Drawer>
  )
}

export default ViewScheduleDrawer